module.exports = __webpack_public_path__ + "img/home.6db6bb8b.png";